import { Image, UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import starSvg from './icons/star.svg';

import * as styles from './SuperAgentBadge.css';

export type TSuperAgentBadgeProps = {
  levelName: string;
};

export const SuperAgentBadge = ({ levelName }: TSuperAgentBadgeProps) => {
  return (
    <div data-testid="super-agent-badge" className={styles['wrapper']}>
      <Image src={starSvg} height={16} width={16} />
      <UIHeading5 color="success_100">{levelName}</UIHeading5>
    </div>
  );
};
